import "./EditOperatorStation.html";
import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditOperatorStationController from "./EditOperatorStationComponentController";

export class EditOperatorStationComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditOperatorStationController;
        this.templateUrl = "/App/Components/AlarmCentralDialogs/EditOperatorStation.html";
    }
}

module("mmManagePortal").component("irEditOperatorStation", new EditOperatorStationComponent());
